import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /practitioners/:practitionerId/*. Renders <Outlet />
 * so child routes (`/` index = detail screen, `/edit` = edit form) appear here.
 *
 * If this returned the detail screen directly, the edit child would have
 * nowhere to render and clicking "Edit profile" would silently fail.
 */
export const Route = createFileRoute('/_staff/admin/workspace/practitioners/$practitionerId')({
  beforeLoad: () => {
    requirePermission('practitioner:read');
  },
  component: WorkspacePractitionerLayout,
  staticData: { crumb: 'Practitioner' },
});

function WorkspacePractitionerLayout() {
  return <Outlet />;
}
